import React from 'react'
import Link from 'gatsby-link'
import avatar from "../global/assets/avatar.jpg"
import { Button, Icon } from 'antd'


const IndexPage = ({ data }) => {

  return (
    <div>

      <h1>My name is Dhruv Kumar Jha, I'm a Full Stack Architect, Working on Interesting Products & Services.</h1>

      <div className="page--index flex">
        <div className="avatar flex--one">
          <img src={ avatar } alt="Dhruv Kumar Jha" />
        </div>
        <div className="flex--two">
          <p>Here I share my experience in the technologies I work with.</p>
          <p>I write tutorials and articles on <strong>Javascript</strong>, <strong>React JS</strong>, <strong>Node JS</strong>, <strong>AWS</strong>, <strong>GraphQL</strong> <strong>Algorithms</strong>, <strong>Python</strong>, <strong>Machine Learning</strong> and related technologies.</p>
          <div className="social--links">
            <a href="https://github.com/dhruv-kumar-jha" target="_blank"><Icon type="github" /></a>
            <a href="https://twitter.com/dhruv_kumar_jha" target="_blank"><Icon type="twitter" /></a>
            <a href="https://www.linkedin.com/in/dhruvkumarjha" target="_blank"><Icon type="linkedin" /></a>
          </div>
        </div>
      </div>

    </div>
  );

}


export default IndexPage


/*
<h4 style={{ marginBottom: 0, color: '#999' }}>Hi and Welcome to my Website.</h4>
<h1>I'm a Full Stack Architect, Working on Products, Services & APIs that makes things simple and interesting.</h1>
<h1>My name is Dhruv Kumar Jha, I'm a Full Stack Architect, Working on Interesting Products, Services & APIs.</h1>

*/



// WEBPACK FOOTER //
// ./src/pages/index.js